import {CookieOptionType} from '../../core/cookiesConsent/cookieOption';
import AitiProductImpressionsCollector from './impressions/collector.mjs';

/**
 * @class
 */
var AitiProductImpressions = function() {

    let _this = this;

    this.ajaxUrl = null;
    this.source = null;
    this.storage = null;
    this.impressionsCached = [];

    this.init = function(ajaxUrl, source) {
        this.ajaxUrl = ajaxUrl;
        this.source = source;

        //TODO: push to GTM, optimize Aiti_GoogleTagManager_Helper_Ecommerce::getImpressionsPush
        /*this.getCollector().onCollect(function(event) {
            _this.impressionsCached.push(event.getData().impression);
            _this.pushDebounced();
        });

        this.onReceive(function(event) {
            _this.addImpression(event.getData().impression);
            _this.dispatchDebounced();
        });*/

        this.getCollector().onCollect(function(event) {
            if (AitiCookiesConsent.getOption(CookieOptionType.MARKETING).isAllowed()) {
                _this.addImpression(event.getData().impression);
                _this.dispatchDebounced();
            }
        });
    };

    this.getAjaxUrl = function() {
        return this.ajaxUrl;
    };

    this.getSource = function() {
        return this.source;
    };

    /**
     * @returns {StorageFactory}
     */
    this.getStorage = function() {
        if (!this.storage) {
            this.storage = new StorageFactory(window.localStorage, 'product_impression_');
        }

        return this.storage;
    };

    /**
     * @returns {AitiProductImpressionsCollector}
     */
    this.getCollector = function() {
        if (!this.collector) {
            this.collector = new AitiProductImpressionsCollector();
        }

        return this.collector;
    };

    /**
     * @returns {Object.<string, Object>}
     */
    this.getImpressions = function() {
        return this.getStorage().getItem('products');
    };

    this.clearImpressions = function() {
        this.getStorage().removeItem('products');
    };

    /**
     * @param {AitiProductImpression} impression
     */
    this.addImpression = function(impression) {
        let impressions = this.getImpressions();

        if (!impressions) {
            impressions = {};
        }

        if (!impression.getSource()) {
            impression.setSource(this.getSource());
        }

        if (!impression.getSource()) {
            return;
        }

        if (impressions.hasOwnProperty(impression.getKey())) {
            impression.setCount(impressions[impression.getKey()].count + 1);
        }

        impressions[impression.getKey()] = impression;
        this.getStorage().setItem('products', impressions);
    };

    this.pushDebounced = $j.debounce(300, false, function() {
        _this.push(_this.impressionsCached);
        _this.impressionsCached = [];
    });

    /**
     * @param {AitiProductImpression[]} impressions
     */
    this.push = function(impressions) {
        let impressionChunks = AitiCore.getUtils().arrayChunk(impressions, 15);

        impressionChunks.forEach(function(chunk) {
            let impressionsToPush = [];

            chunk.forEach(function(impression) {
                AitiCore.getClients().getGtmClient().getDataLayer().forEach(function(entry) {
                    if (entry.event == 'productImpression') {
                        entry.ecommerce.impressions.forEach(function(impressionEntry) {
                            if (impressionEntry.aiti_product_self_id == impression.getProductId()) {
                                impressionEntry['aiti_impression'] = impression;
                                impressionsToPush.push(impressionEntry);
                            }
                        });
                    }
                });
            });

            AitiCore.getClients().getGtmClient().getDataLayer().push({
                event: 'productImpressionViewed',
                ecommerce: {
                    impressionsViewed: {
                        items: impressionsToPush,
                        count: impressionsToPush.length
                    },
                }
            });
        });
    };

    this.dispatchDebounced = $j.debounce(3000, false, function() {
        _this.dispatch();
    });

    this.dispatch = function() {
        let impressions = this.getImpressions();

        if ($j.isEmptyObject(impressions)) {
            return;
        }

        $j.post(this.getAjaxUrl(), {impressions: Object.values(impressions)});
        this.clearImpressions();
    };

    /**
     * @param {function(DeferredEvent)} handler
     * @param {int} [priority=CartEvents.PRIORITY_NORMAL]
     * @param {boolean} [ignoreCancel=false]
     */
    this.onReceive = function(handler, priority, ignoreCancel) {
        DeferredEvents.listen(AitiProductImpressions.EVENT_RECEIVE, handler, priority, ignoreCancel, this);
        return this;
    };
};

/** EVENTS */
AitiProductImpressions.EVENT_RECEIVE = 'product_impression_receive';

/** @type {AitiProductImpressions} */
window.AitiProductImpressions = new AitiProductImpressions();

export default window.AitiProductImpressions;
